import {
  IRoomDimensionsOptions,
  ICapacityOptions,
  IFilterCategories,
  ISortingOptionKeys,
  IStageCapacityType,
} from "Venues/types";

export const capacityFilterOptions = {
  [ICapacityOptions["0_99"]]: "0 - 99",
  [ICapacityOptions["100_499"]]: "100 - 499",
  [ICapacityOptions["500_999"]]: "500 - 999",
  [ICapacityOptions["1000_4999"]]: "1.000 - 4.999",
  [ICapacityOptions["5000_9999"]]: "5.000 - 9.999",
  [ICapacityOptions["10000_49999"]]: "10.000 - 49.999",
  [ICapacityOptions["50000+"]]: "50.000+",
};

export const capacityTypeOptions = {
  [IStageCapacityType.generalAdmission]: "General admission",
  [IStageCapacityType.seated]: "Seated",
  [IStageCapacityType.standing]: "Standing",
  [IStageCapacityType.mixed]: "Mixed",
};

export const areaFilterOptions = {
  [IRoomDimensionsOptions["0_99"]]: "100 m²",
  [IRoomDimensionsOptions["100_999"]]: "1.000 m²",
  [IRoomDimensionsOptions["1000_4999"]]: "5.000 m²",
  [IRoomDimensionsOptions["5000_9999"]]: "10.000 m²",
  [IRoomDimensionsOptions["10000+"]]: "10.000+ m²",
};

export const sortingOptions = {
  [ISortingOptionKeys.updatedAtDesc]: "last updated",
  [ISortingOptionKeys.titleAsc]: "A to Z",
};

export const apiSortingOptions: {
  [key in ISortingOptionKeys]: { field: string; direction: "asc" | "desc" };
} = {
  [ISortingOptionKeys.updatedAtDesc]: {
    field: "updatedAt",
    direction: "desc",
  },
  [ISortingOptionKeys.titleAsc]: {
    field: "title",
    direction: "asc",
  },
};

export const getFilterFacets: any = (category: IFilterCategories) => {
  switch (category) {
    case IFilterCategories.capacity:
      return capacityFilterOptions;
    case IFilterCategories.roomDimension:
      return areaFilterOptions;
    case IFilterCategories.capacityType:
      return capacityTypeOptions;
    default:
      return {};
  }
};
